<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <section class="section-hotels-edit-rooms">
                        <div class="hotels-wrap">
                          <HotelsSideMenu />
                            <div class="lds-ring" v-if="!isLoad">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div class="hotels-content" v-if="isLoad">
                                <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                                <div class="hotel-inner-prices">
                                    <form>
                                        <div class="page-title-2">
                                            <h2>Special Offers</h2>
                                        </div>
                                        <div class="prices-top">
                                            <div class="line-cols">
                                                <div class="form-control-group">
                                                    <span class="form-control-label">Year</span>
                                                    <div class="form-control-wrap">
                                                        <div
                                                            :class="['select-wrapper', { 'is-active' : selects.year }]"
                                                            @click="openSelect('year')"
                                                        >
                                                            <div class="select-trigger">
                                                                <span class="select-trigger__name">{{
                                                                        year || ''
                                                                    }}</span>
                                                                <span class="select-trigger__icon">
                                  <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                  </svg>
                                </span>
                                                            </div>
                                                            <div class="select-body">
                                                                <div class="select-inner">
                                                                    <div
                                                                        v-for="(item, index) in data.years" :key="index"
                                                                        :class="['select-option', { 'is-selected' : item === year }]"
                                                                        @click="year = item"
                                                                    >
                                                                        <span class="select-option__name">{{
                                                                                item
                                                                            }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="btn_copy-price">
                                                    <button
                                                        @click="copyPopup = true"
                                                        type="button"
                                                        data-popover="Copy rates from the previous year"
                                                        class="btn btn--green btn--sm-squared btn--popover"
                                                    >
                                                        <svg width="1em" height="1em" class="icon icon-copy ">
                                                            <use
                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="line-special">
                                            <div class="hotel-subtitle">Special offers</div>
                                            <div class="line-special__item">
                                                <div class="line-special__item-row">

                                                    <div class="form-control-group">
                                                        <div
                                                            class="select-wrapper select-wrapper--price-hotel"
                                                            :class="['select-wrapper', { 'is-active' : selects.offerSelected }]"
                                                            @click="openSelect('offerSelected')"
                                                        >
                                                            <div class="select-trigger">
                                                                <span class="select-trigger__name">{{
                                                                        offerSelected.title || ''
                                                                    }}</span>
                                                                <span class="select-trigger__icon">
                                  <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                  </svg>
                                </span>
                                                            </div>
                                                            <div class="select-body">
                                                                <div class="select-inner">
                                                                    <div
                                                                        v-for="(item, index) in data.offersList"
                                                                        :key="index"
                                                                        :class="['select-option', { 'is-selected' : item === offerSelected }]"
                                                                        @click="offerSelected = item"
                                                                    >
                                                                        <span class="select-option__name">{{
                                                                                item.title
                                                                            }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <button
                                                    @click="addToOfferArray"
                                                    type="button"
                                                    class="btn btn--rounded2 btn--green"
                                                    style="margin-bottom: 20px;"
                                                >
                                                    <span>Add Special Offer</span>
                                                </button>

                                                <div
                                                    v-for="(offerObj, index) in offersData.offers"
                                                    :key="index"
                                                    :class="['line-special__item-row',
                            { 'line-special__item-row-mod line-special__item-row-mod--wrap': offerObj && offerObj.offer && offerObj.offer.type === 'HONEYMOON_PACKAGE' }]"
                                                >
                                                    <template v-if="offerObj && offerObj.offer.type === 'EARLY_BIRD'">
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">If hotel booked</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days',
                                  { 'is-error' : offerObj.offer.ifHotelBookedError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.ifHotelBooked"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.ifHotelBookedError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>days in<br> advance</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Discount</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap__sm',
                                  { 'is-error' : offerObj.offer.discountError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.discount"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.discountError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>%</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-control-datepicker form-control-datepicker--labeled">
                                                            <div class="form-control-group">
                                                                <span
                                                                    class="form-control-label-main">Travel Dates</span>
                                                                <span class="form-control-label">From</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.travelDateFromError }]">
                                                                    <input
                                                                        type="text" placeholder="Date From"
                                                                        v-model="offerObj.offer.travelDateFrom"
                                                                        @focus="offerObj.offer.travelDateFromError = false"
                                                                        @blur="offerObj.offer.travelDateFrom = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="form-control-group">
                                                                <span class="form-control-label">To</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.travelDateToError }]">
                                                                    <input
                                                                        type="text" placeholder="Date To"
                                                                        v-model="offerObj.offer.travelDateTo"
                                                                        @focus="offerObj.offer.travelDateToError = false"
                                                                        @blur="offerObj.offer.travelDateTo = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template
                                                        v-if="offerObj && offerObj.offer.type === 'STAY_FOUR_PAY_THREE'">
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">If stay</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days',
                                { 'is-error' : offerObj.offer.ifStayNightsError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.ifStayNights"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.ifStayNightsError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>Nights</span></div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Pay only for</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days',
                                  { 'is-error' : offerObj.offer.payOnlyForNightsError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.payOnlyForNights"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.payOnlyForNightsError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>Nights</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-control-datepicker form-control-datepicker--labeled">
                                                            <div class="form-control-group">
                                                                <span class="form-control-label-main">Valid</span>
                                                                <span class="form-control-label">From</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateFromError }]">
                                                                    <input
                                                                        type="text" placeholder="Date From"
                                                                        v-model="offerObj.offer.validDateFrom"
                                                                        @focus="offerObj.offer.validDateFromError = false"
                                                                        @blur="offerObj.offer.validDateFrom = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="form-control-group">
                                                                <span class="form-control-label">To</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateToError }]">
                                                                    <input
                                                                        type="text" placeholder="Date To"
                                                                        v-model="offerObj.offer.validDateTo"
                                                                        @focus="offerObj.offer.validDateToError = false"
                                                                        @blur="offerObj.offer.validDateTo = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template
                                                        v-if="offerObj && offerObj.offer.type === 'STAY_LONG_AND_GET_DISCOUNT'">
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">If stay</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days',
                                  { 'is-error' : offerObj.offer.ifStayNightsError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.ifStayNights"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.ifStayNightsError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>Nights</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Get discount</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap__md',
                                  { 'is-error' : offerObj.offer.discountError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.discount"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.discountError = false"
                                                                >
                                                                <div
                                                                    class="form-control-label-descr form-control-label-descr-select">
                                                                    <div
                                                                        :class="[
                                      'select-wrapper select-wrapper--price-hotel',
                                      { 'is-active' : offerObj.offer.active }
                                    ]"
                                                                        @click="offersData.offers = offersData.offers.map((cur, i) => ({ ...cur, offer: { ...cur.offer, active: i === index ? !cur.offer.active : false } }))"
                                                                    >
                                                                        <div class="select-trigger">
                                      <span class="select-trigger__name">
                                        {{ offerObj.offer.discountType === 'AMOUNT' ? '$' : '%' }}
                                      </span>
                                                                            <span class="select-trigger__icon">
                                      <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                      </svg>
                                    </span>
                                                                        </div>
                                                                        <div class="select-body">
                                                                            <div class="select-inner">
                                                                                <div
                                                                                    v-for="(item, index) in ['$', '%']"
                                                                                    :key="index"
                                                                                    class="select-option"
                                                                                    @click="item === '$' ? offerObj.offer.discountType = 'AMOUNT' : offerObj.offer.discountType = 'PERCENT'"
                                                                                >
                                                                                    <span class="select-option__name">{{
                                                                                            item
                                                                                        }}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-control-datepicker form-control-datepicker--labeled">
                                                            <div class="form-control-group">
                                                                <span class="form-control-label-main">Valid</span>
                                                                <span class="form-control-label">From</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateFromError }]">
                                                                    <input
                                                                        type="text" placeholder="Date From"
                                                                        v-model="offerObj.offer.validDateFrom"
                                                                        @focus="offerObj.offer.validDateFromError = false"
                                                                        @blur="offerObj.offer.validDateFrom = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="form-control-group">
                                                                <span class="form-control-label">To</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateToError }]">
                                                                    <input
                                                                        type="text" placeholder="Date To"
                                                                        v-model="offerObj.offer.validDateTo"
                                                                        @focus="offerObj.offer.validDateToError = false"
                                                                        @blur="offerObj.offer.validDateTo = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template
                                                        v-if="offerObj && offerObj.offer.type === 'FIFTY_PERCENT_DISCOUNT_ON_THE_LAST_NIGHT'">
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">If stay</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days',
                                  { 'is-error' : offerObj.offer.ifStayNightsError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.ifStayNights"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.ifStayNightsError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>Nights</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Last night discount</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap__lg',
                                  { 'is-error' : offerObj.offer.discountError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.discount"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.discountError = false"
                                                                >
                                                                <div class="form-control-label-descr"><span>%</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-control-datepicker form-control-datepicker--labeled">
                                                            <div class="form-control-group">
                                                                <span class="form-control-label-main">Valid</span>
                                                                <span class="form-control-label">From</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateFromError }]">
                                                                    <input
                                                                        type="text" placeholder="Date From"
                                                                        v-model="offerObj.offer.validDateFrom"
                                                                        @focus="offerObj.offer.validDateFromError = false"
                                                                        @blur="offerObj.offer.validDateFrom = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="form-control-group">
                                                                <span class="form-control-label">To</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateToError }]">
                                                                    <input
                                                                        type="text" placeholder="Date To"
                                                                        v-model="offerObj.offer.validDateTo"
                                                                        @focus="offerObj.offer.validDateToError = false"
                                                                        @blur="offerObj.offer.validDateTo = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template
                                                        v-if="offerObj && offerObj.offer.type === 'CIRCUIT_DISCOUNT'">
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">If booked more than</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap--days-mod',
                                  { 'is-error': offerObj.offer.ifBookedMoreThanNightsError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.ifBookedMoreThanNights"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.ifBookedMoreThanNightsError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>Nights</span></div>
                                                            </div>
                                                            <span
                                                                class="form-control-label-add">for this hotel chain</span>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Discount</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap__sm',
                                { 'is-error' : offerObj.offer.discountError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.discount"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.discountError = false"
                                                                >
                                                                <div class="form-control-label-descr"><span>%</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Exclude lodge from the calculation:</span>
                                                            <div
                                                                :class="['select-wrapper', { 'is-active' : offerObj.offer.active }]"
                                                                @click="offersData.offers = offersData.offers.map((cur, i) => ({ ...cur, offer: { ...cur.offer, active: i === index ? !cur.offer.active : false } }))"
                                                            >
                                                                <div class="select-trigger">
                                  <span class="select-trigger__name">
                                    {{ offerObj.offer.excludeLodge.map(item => item.title).join(', ') }}
                                  </span>
                                                                    <span class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg>
                                  </span>
                                                                </div>
                                                                <div class="select-body">
                                                                    <div class="select-inner">
                                                                        <div
                                                                            v-for="item in offerObj.offer.hotelsList"
                                                                            :key="item.title"
                                                                            :class="['select-option', { 'is-selected' : item.active }]"
                                                                        >
                                                                            <label
                                                                                class="form-control-checkbox form-control-checkbox-add-flight"
                                                                                @click.prevent.stop="
                                          item.active = !item.active; offerObj.offer.excludeLodge = offerObj.offer.hotelsList.filter(hotel => hotel.active)
                                        "
                                                                            >
                                                                                <!--                                    <input type="checkbox" :checked="offerObj.offer.excludeLodge.map(lodge => lodge.id).includes(item.id)" @click.prevent.stop>-->
                                                                                <input type="checkbox"
                                                                                       :checked="item.active"
                                                                                       @click.prevent.stop>
                                                                                <span
                                                                                    class="form-control-checkbox__box">
                                          <svg width="1em" height="1em" class="icon icon-check ">
                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                          </svg>
                                        </span>
                                                                                <span class="select-option__name">{{
                                                                                        item.title
                                                                                    }}</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template
                                                        v-if="offerObj && offerObj.offer.type === 'HONEYMOON_PACKAGE'">
                                                        <div class="form-control-group">
                                                            <span
                                                                class="form-control-label">If married not more than</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap--days-mod',
                                  { 'is-error': offerObj.offer.ifMarriedNotMoreThanDaysError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.ifMarriedNotMoreThanDays"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.ifMarriedNotMoreThanDaysError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>Days ago</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span
                                                                class="form-control-label">And stay not less than</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap--days-mod',
                                { 'is-error': offerObj.offer.stayNotLessThanError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.stayNotLessThan"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.stayNotLessThanError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>Nights</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Discount</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap__sm',
                                  { 'is-error' : offerObj.offer.discountError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.discount"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.discountError = false"
                                                                >
                                                                <div class="form-control-label-descr"><span>%</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Apply discount on</span>
                                                            <div
                                                                :class="['select-wrapper select-wrapper--lg', {
                                  'is-active': offerObj.offer.active
                                }]"
                                                                @click="offersData.offers = offersData.offers.map((cur, i) => ({ ...cur, offer: { ...cur.offer, active: i === index ? !cur.offer.active : false } }))"
                                                            >
                                                                <div class="select-trigger">
                                  <span class="select-trigger__name">
                                    {{
                                          offerObj.offer.applyDiscountOn === 'LAST_NIGHT' ? 'Last night' : 'All accommodation'
                                      }}
                                  </span>
                                                                    <span class="select-trigger__icon">
                                  <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                  </svg>
                                </span>
                                                                </div>
                                                                <div class="select-body">
                                                                    <div class="select-inner">
                                                                        <div
                                                                            v-for="(item, index) in ['All accommodation', 'Last night']"
                                                                            :key="index"
                                                                            class="select-option"
                                                                            @click="item === 'All accommodation' ?
                                          offerObj.offer.applyDiscountOn = 'ALL_ACCOMMODATION' : offerObj.offer.applyDiscountOn = 'LAST_NIGHT'"
                                                                        >
                                                                            <span class="select-option__name">{{
                                                                                    item
                                                                                }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-control-datepicker form-control-datepicker--labeled">
                                                            <div class="form-control-group">
                                                                <span class="form-control-label">Valid From</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateFromError }]">
                                                                    <input
                                                                        type="text" placeholder="Date From"
                                                                        v-model="offerObj.offer.validDateFrom"
                                                                        @focus="offerObj.offer.validDateFromError = false"
                                                                        @blur="offerObj.offer.validDateFrom = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="form-control-group">
                                                                <span class="form-control-label">Valid<br> To</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateToError }]">
                                                                    <input
                                                                        type="text" placeholder="Date To"
                                                                        v-model="offerObj.offer.validDateTo"
                                                                        @focus="offerObj.offer.validDateToError = false"
                                                                        @blur="offerObj.offer.validDateTo = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template
                                                        v-if="offerObj && offerObj.offer.type === 'GROUP_DISCOUNT'">
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Group of more than</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap--days-mod',
                                  { 'is-error': offerObj.offer.groupMoreThanPeopleError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.groupMoreThanPeople"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.groupMoreThanPeopleError = false"
                                                                >
                                                                <div class="form-control-label-descr">
                                                                    <span>People</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">Discount</span>
                                                            <div
                                                                :class="['form-control-wrap form-control-wrap--days form-control-wrap__sm',
                                  { 'is-error': offerObj.offer.discountError }]"
                                                            >
                                                                <input
                                                                    v-model.number="offerObj.offer.discount"
                                                                    type="number" placeholder="0" class="form-control"
                                                                    @focus="offerObj.offer.discountError = false"
                                                                >
                                                                <div class="form-control-label-descr"><span>%</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-control-datepicker form-control-datepicker--labeled">
                                                            <div class="form-control-group">
                                                                <span
                                                                    class="form-control-label-main">Travel Dates</span>
                                                                <span class="form-control-label">From</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateFromError }]">
                                                                    <input
                                                                        type="text" placeholder="Date From"
                                                                        v-model="offerObj.offer.validDateFrom"
                                                                        @focus="offerObj.offer.validDateFromError = false"
                                                                        @blur="offerObj.offer.validDateFrom = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="form-control-group">
                                                                <span class="form-control-label">To</span>
                                                                <div
                                                                    :class="['form-control-wrap', { 'is-error': offerObj.offer.validDateToError }]">
                                                                    <input
                                                                        type="text" placeholder="Date To"
                                                                        v-model="offerObj.offer.validDateTo"
                                                                        @focus="offerObj.offer.validDateToError = false"
                                                                        @blur="offerObj.offer.validDateTo = $event.target.value"
                                                                        class="form-control js-datepicker-single"
                                                                    >
                                                                    <div class="form-control-icon">
                                                                        <svg width="1em" height="1em"
                                                                             class="icon icon-calendar ">
                                                                            <use
                                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <button
                                                        v-if="offerObj.offer"
                                                        type="button"
                                                        class="btn btn--remove btn_remove-festive"
                                                        @click="$emit('deleteModalHandler', {
                                  entity: 'Offer',
                                  name: 'this',
                                  handler: deleteOffer,
                                  id: index
                              })"
                                                    >
                                                        <svg width="1em" height="1em" class="icon icon-close">
                                                            <use
                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="edit-rooms__btn-edit edit-rooms__btn-edit_prices">
                                            <button @click="updatePopup = true" type="button" class="btn btn--green">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="modal-wrapper" v-if="copyPopup">
                                <div class="modal-backdrop"></div>
                                <div class="modal-inner">
                                    <div class="edit-popup edit-popup--copy-md">
                                        <div class="edit-popup__header">
                                            <div class="edit-popup__title">
                                                <div class="edit-popup__title__icon">
                                                    <svg width="1em" height="1em" class="icon icon-recover">
                                                        <use
                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                                                    </svg>
                                                </div>
                                                <span>Copy from another year</span>
                                            </div>
                                            <div class="edit-popup__close" @click="copyPopup = false">
                                                <svg width="1em" height="1em" class="icon icon-close ">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                </svg>
                                            </div>
                                        </div>
                                        <form action="javascript:void(0)" class="edit-popup__inner">
                                            <div class="edit-popup__form-2">
                                                <div class="form-control-group"><span class="form-control-label">Choose year</span>
                                                    <div :class="['select-wrapper', { 'is-active' : copyPopupOpen }]"
                                                         @click="copyPopupOpen = !copyPopupOpen">
                                                        <div class="select-trigger">
                                                            <span class="select-trigger__name">{{
                                                                    copyPopupFrom
                                                                }}</span>
                                                            <span class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg>
                              </span>
                                                        </div>
                                                        <div class="select-body">
                                                            <div class="select-inner js-scrollbar">
                                                                <div
                                                                    v-for="(y, index) in data.years.filter(y => !(y === copyPopup))"
                                                                    :key="index"
                                                                    :class="['select-option', { 'is-selected' : copyPopupFrom === y }]"
                                                                    @click="copyPopupFrom = y">
                                                                    <span class="select-option__name">{{ y }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="submit" class="btn btn--green edit-popup__submit-2"
                                                        @click="copyYearOldHandler();copyPopup = false">
                                                    <svg width="1em" height="1em" class="icon icon-recover">
                                                        <use
                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                                                    </svg>
                                                    <span>Copy</span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-wrapper" v-if="updatePopup">
                                <div class="modal-backdrop"></div>
                                <div class="modal-inner">
                                    <div class="edit-popup edit-popup--history">
                                        <div class="edit-popup__header">
                                            <div class="edit-popup__title">
                                                Update History
                                            </div>
                                            <div class="edit-popup__close" @click="updatePopup = false">
                                                <svg width="1em" height="1em" class="icon icon-close ">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                </svg>
                                            </div>
                                        </div>
                                        <form action="javascript:void(0)" class="edit-popup__inner">
                                            <div class="form-control-group"><span
                                                class="form-control-label">Hi {{
                                                    user ? user.data.firstName : ''
                                                }}, <span> what have you updated?</span> </span>
                                                <div class="form-control-wrap">
                                                    <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                                                </div>
                                              <div class="edit-popup__error-text">
                                                <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                                              </div>
                                            </div>
                                            <div class="options-additional__btns">
                                                <button type="button" class="btn btn--silver"
                                                        @click="updatePopup = false">
                                                    <span>Cancel</span>
                                                </button>
                                                <button type="submit" class="btn btn--green edit-popup__submit"
                                                        :disabled="descriptionUpdate.length < 6"
                                                        @click="fetchOffers">
                                                    <span>Update</span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Lightpick from 'lightpick'
import {
    getHotelAdvanced,
    getHotelsAdvanced,
    getHotelsOffers,
    postSpecialOffers,
    copySpecialOffers
} from '@/utilites/api'
import {date} from "@/utilites/functions";
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
  components: {HotelsSideMenu},
    data() {
        return {
            copyPopup: false,
            updatePopup: false,
            copyPopupFrom: '',
            copyPopupOpen: false,
            descriptionUpdate: '',
            year: new Date().getFullYear(),
            offerSelected: {
                title: '',
                value: ''
            },
            copyHotel: null,
            copyYear: null,
            isEdit: false,
            offersData: {
                offers: [{offer: {}}],
                history: {}
            },
            selects: {
                year: false,
                offerSelected: false,
                hotel: false,
                copyHotel: false,
                copyYear: false,
            },
            dataHotels: [],
            data: {
                years: [],
                offersList: [
                    {title: 'Early Bird', value: 'specialOfferEarlyBird'},
                    {title: 'Stay 4 pay 3', value: 'specialOfferStayFourPayThree'},
                    {title: 'Stay long and get discount', value: 'specialOfferStayLongAndGetDiscount'},
                    {title: '50% off the third night', value: 'specialOfferFiftyPercentDiscountOnTheLastNight'},
                    {title: 'Circuit Discount', value: 'specialOfferCircuitDiscount'},
                    {title: 'Honeymoon Package', value: 'specialOfferHoneymoonPackage'},
                    {title: 'Group Discount', value: 'specialOfferGroupDiscount'},
                ],
                offersTemplates: {
                    specialOfferEarlyBird: {
                        type: 'EARLY_BIRD',
                        ifHotelBooked: null,
                        discount: null,
                        discountType: 'PERCENT',
                        travelDateFrom: '',
                        travelDateTo: '',
                    },
                    specialOfferStayFourPayThree: {
                        type: 'STAY_FOUR_PAY_THREE',
                        ifStayNights: null,
                        payOnlyForNights: null,
                        validDateFrom: '',
                        validDateTo: '',
                    },
                    specialOfferStayLongAndGetDiscount: {
                        type: 'STAY_LONG_AND_GET_DISCOUNT',
                        ifStayNights: null,
                        discount: null,
                        discountType: 'AMOUNT',
                        active: false,
                        validDateFrom: '',
                        validDateTo: '',
                    },
                    specialOfferFiftyPercentDiscountOnTheLastNight: {
                        type: 'FIFTY_PERCENT_DISCOUNT_ON_THE_LAST_NIGHT',
                        ifStayNights: null,
                        discount: null,
                        discountType: 'PERCENT',
                        validDateFrom: '',
                        validDateTo: '',
                    },
                    specialOfferCircuitDiscount: {
                        type: 'CIRCUIT_DISCOUNT',
                        ifBookedMoreThanNights: null,
                        discount: null,
                        discountType: 'PERCENT',
                        excludeLodge: [],
                        active: false,
                    },
                    specialOfferHoneymoonPackage: {
                        type: 'HONEYMOON_PACKAGE',
                        ifMarriedNotMoreThanDays: null,
                        stayNotLessThan: null,
                        discount: null,
                        discountType: 'PERCENT',
                        applyDiscountOn: 'ALL_ACCOMMODATION',
                        active: false,
                        validDateFrom: '',
                        validDateTo: ''
                    },
                    specialOfferGroupDiscount: {
                        type: 'GROUP_DISCOUNT',
                        groupMoreThanPeople: null,
                        discount: null,
                        discountType: 'PERCENT',
                        validDateFrom: '',
                        validDateTo: '',
                    }
                },
                hotels: [],
            },
            hotelName: '',
            hotelChainId: null,
            isLoad: false,
            description: ''
        }
    },
    props: ['user'],
    beforeRouteLeave(to, from, next) {
        if (this.isEdit) {
            this.$emit('notLeaveHandler')
        }
        next()
    },
    created() {
        getHotelAdvanced(this.$route.params.id).then(res => {
            this.hotelName = res.names.EN
            this.hotelChainId = res.chainId
        })
    },
    mounted() {
        this.updateData()
        const tempYears = [];
        const lastYear = new Date().getFullYear() + 10;
        for (let i = 2021; i < lastYear; i++) {
          tempYears.push(i);
        }
        this.data.years = tempYears;
        window.addEventListener('click', event => {
            if (!event.target.closest('.select-wrapper')) {
                this.selects = {
                    year: false,
                    offerSelected: false,
                    hotel: false,
                    copyHotel: false,
                    copyYear: false,
                }
                if (this.offersData.offers.length) {
                    this.offersData.offers = this.offersData.offers.map(item => ({
                        ...item,
                        active: false,
                        offer: {
                            ...item.offer,
                            active: false,
                        }
                    }))
                }
            }
        })
    },
    methods: {
        checkErrors() {
            let error = false
            this.offersData.offers = this.offersData.offers.map(item => {
                if (item.offer.type !== 'STAY_FOUR_PAY_THREE' && !item.offer.discount) {
                    error = true
                    item.offer.discountError = true
                }
                if (item.offer.type === 'EARLY_BIRD') {
                    if (!item.offer.ifHotelBooked) {
                        error = true
                        item.offer.ifHotelBookedError = true
                    }
                    if (!item.offer.travelDateFrom) {
                        error = true
                        item.offer.travelDateFromError = true
                    }
                    if (!item.offer.travelDateTo) {
                        error = true
                        item.offer.travelDateToError = true
                    }
                }
                if ((item.offer.type !== 'EARLY_BIRD' &&
                    item.offer.type !== 'CIRCUIT_DISCOUNT'
                ) && !item.offer.validDateFrom) {
                    error = true
                    item.offer.validDateFromError = true
                }
                if ((item.offer.type !== 'EARLY_BIRD' &&
                    item.offer.type !== 'CIRCUIT_DISCOUNT'
                ) && !item.offer.validDateTo) {
                    error = true
                    item.offer.validDateToError = true
                }

                if ((item.offer.type === 'STAY_FOUR_PAY_THREE' ||
                        item.offer.type === 'STAY_LONG_AND_GET_DISCOUNT' ||
                        item.offer.type === 'FIFTY_PERCENT_DISCOUNT_ON_THE_LAST_NIGHT'
                    )
                    && !item.offer.ifStayNights) {
                    error = true
                    item.offer.ifStayNightsError = true
                }
                if (item.offer.type === 'STAY_FOUR_PAY_THREE' && !item.offer.payOnlyForNights) {
                    error = true
                    item.offer.payOnlyForNightsError = true
                }
                if (item.offer.type === 'CIRCUIT_DISCOUNT' && !item.offer.ifBookedMoreThanNights) {
                    error = true
                    item.offer.ifBookedMoreThanNightsError = true
                }
                if (item.offer.type === 'HONEYMOON_PACKAGE') {
                    if (!item.offer.ifMarriedNotMoreThanDays) {
                        error = true
                        item.offer.ifMarriedNotMoreThanDaysError = true
                    }
                    if (!item.offer.stayNotLessThan) {
                        error = true
                        item.offer.stayNotLessThanError = true
                    }
                }
                if (item.offer.type === 'GROUP_DISCOUNT' && !item.offer.groupMoreThanPeople) {
                    error = true
                    item.offer.groupMoreThanPeopleError = true
                }

                return item
            })
            return error
        },
        copyYearOldHandler() {
            Promise.all([copySpecialOffers(this.$route.params.id, this.copyPopupFrom, this.year), getHotelsAdvanced()])
                .then(res => {
                    this.data.hotels = res[1]
                        .filter(hotel => hotel.chainId && hotel.chainId === this.hotelChainId)
                        .map(item => ({...item, active: false}))
                        .sort((a, b) => a.title > b.title ? 1 : -1)
                    this.offersData.offers = res[0].data
                    res[0].data.map(item => {
                        if (item.offer.travelDateFrom) item.offer.travelDateFrom = date(item.offer.travelDateFrom, 'fromStart')
                        if (item.offer.travelDateTo) item.offer.travelDateTo = date(item.offer.travelDateTo, 'fromStart')
                        if (item.offer.duringPeriodDateFrom) item.offer.duringPeriodDateFrom = date(item.offer.duringPeriodDateFrom, 'fromStart')
                        if (item.offer.duringPeriodDateTo) item.offer.duringPeriodDateTo = date(item.offer.duringPeriodDateTo, 'fromStart')
                        if (item.offer.validDateFrom) item.offer.validDateFrom = date(item.offer.validDateFrom, 'fromStart')
                        if (item.offer.validDateTo) item.offer.validDateTo = date(item.offer.validDateTo, 'fromStart')
                        if (item.offer.type === 'CIRCUIT_DISCOUNT') {
                            item.offer.excludeLodge = this.data.hotels.filter(hotel => item.offer.excludeLodge.includes(hotel.id))
                            item.offer.hotelsList = this.data.hotels.map(hotel => ({
                                ...hotel,
                                active: item.offer.excludeLodge.map(lodge => lodge.id).includes(hotel.id)
                            }))
                        }
                    })
                    this.isLoad = true
                })
        },
        deleteOffer(index) {
            this.offersData.offers.splice(index, 1)
        },
        fetchOffers() {
            if (!this.checkErrors()) {
                postSpecialOffers(this.normalizeDataOffers(), this.$route.params.id, this.year)
                    .then(() => {
                        this.updateData()
                        this.$emit('confirmed')
                        this.updatePopup = false
                        this.descriptionUpdate = ''
                        this.isEdit = false
                    })
            } else {
                this.updatePopup = false
                this.descriptionUpdate = ''
            }
        },
        normalizeDataOffers() {
            const normData = {
                offers: this.offersData.offers.map(item => ({
                    offer: {
                        ...item.offer,
                    },
                    hotelId: item.hotelId || +this.$route.params.id,
                    year: item.year || this.year,
                    id: item.id || null
                })),
                history: {
                    hotelId: +this.$route.params.id,
                    userId: this.user.data.id,
                    description: this.descriptionUpdate
                }
            }
            normData.offers.map(item => {
                if (item.offer.travelDateFrom) item.offer.travelDateFrom = date(item.offer.travelDateFrom, 'start')
                if (item.offer.travelDateTo) item.offer.travelDateTo = date(item.offer.travelDateTo, 'start')
                if (item.offer.duringPeriodDateFrom) item.offer.duringPeriodDateFrom = date(item.offer.duringPeriodDateFrom, 'start')
                if (item.offer.duringPeriodDateTo) item.offer.duringPeriodDateTo = date(item.offer.duringPeriodDateTo, 'start')
                if (item.offer.validDateFrom) item.offer.validDateFrom = date(item.offer.validDateFrom, 'start')
                if (item.offer.validDateTo) item.offer.validDateTo = date(item.offer.validDateTo, 'start')
                if (item.offer.type === 'CIRCUIT_DISCOUNT') item.offer.excludeLodge = item.offer.excludeLodge.map(item => item.id)
            })
            return normData
        },
        addToOfferArray() {
            if (this.data.offersTemplates[`${this.offerSelected.value}`].type === 'CIRCUIT_DISCOUNT') {
                this.offersData.offers.push({
                    offer: {
                        ...this.data.offersTemplates[`${this.offerSelected.value}`],
                        hotelsList: this.data.hotels.map(item => ({
                            ...item,
                            active: false
                        }))
                    },
                })
            } else {
                this.offersData.offers.push({offer: this.data.offersTemplates[`${this.offerSelected.value}`]})
            }
            this.updateDatePickers()
        },
        openSelect(name) {
            this.selects = {
                year: false,
                offerSelected: false,
                hotel: false,
                copyHotel: false,
                copyYear: false,
                [name]: !this.selects[name]
            }
        },
        updateData() {
            Promise.all([getHotelsOffers(this.$route.params.id, this.year), getHotelsAdvanced()])
                .then(res => {
                    this.data.hotels = res[1]
                        .filter(hotel => hotel.chainId && hotel.chainId === this.hotelChainId)
                        .map(item => ({...item, active: false}))
                        .sort((a, b) => a.title > b.title ? 1 : -1)

                    this.offersData.offers = res[0]
                    res[0].map(item => {
                        if (item.offer.travelDateFrom) item.offer.travelDateFrom = date(item.offer.travelDateFrom, 'fromStart')
                        if (item.offer.travelDateTo) item.offer.travelDateTo = date(item.offer.travelDateTo, 'fromStart')
                        if (item.offer.duringPeriodDateFrom) item.offer.duringPeriodDateFrom = date(item.offer.duringPeriodDateFrom, 'fromStart')
                        if (item.offer.duringPeriodDateTo) item.offer.duringPeriodDateTo = date(item.offer.duringPeriodDateTo, 'fromStart')
                        if (item.offer.validDateFrom) item.offer.validDateFrom = date(item.offer.validDateFrom, 'fromStart')
                        if (item.offer.validDateTo) item.offer.validDateTo = date(item.offer.validDateTo, 'fromStart')
                        if (item.offer.type === 'CIRCUIT_DISCOUNT') {
                            item.offer.excludeLodge = this.data.hotels.filter(hotel => item.offer.excludeLodge.includes(hotel.id))
                            item.offer.hotelsList = this.data.hotels.map(hotel => ({
                                ...hotel,
                                active: item.offer.excludeLodge.map(lodge => lodge.id).includes(hotel.id)
                            }))
                        }
                    })
                    this.isLoad = true
                })
        },
        updateDatePickers() {
            document.querySelectorAll('.lightpick').forEach(elem => {
                elem.remove()
            })
            setTimeout(() => {
                document.querySelectorAll('.js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                        onClose: function () {
                            item.blur()
                        },
                        onSelect: function () {
                            item.focus()
                            item.blur()
                        }
                    });
                    item.addEventListener('blur', () => {
                        datePicker.hide()
                    })
                });
            }, 1000)
        },

        waitSaveTiming() {
            const saveFun = () => {
                this.updatePopup = true;
            }
            const waitFun = () => {
                this.waitSaveTiming();
            }
            setTimeout(() => {
                this.$emit('waitSaveHandler', [saveFun, waitFun]);
            }, 10 * 60 * 1000)
        },
    },
    watch: {
        isEdit(val) {
            if (val) this.waitSaveTiming();
        },
        year() {
            this.updateData()
        }
    }
}
</script>
